// TODO: Fetch token from the Factorial backend
const tokenServerUrl = 'https://livekit-token-server-factorial-prod.adriablancafort.workers.dev'

export interface TokenRequestBody {
  participant_attributes?: Record<string, string>
}

export interface TokenResponse {
  serverUrl: string
  participantToken: string
}

export async function fetchToken(body: TokenRequestBody = {}): Promise<TokenResponse> {
  const response = await fetch(`${tokenServerUrl}/token`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch token: ${response.statusText}`)
  }

  const { server_url, participant_token } = await response.json()
  return { serverUrl: server_url, participantToken: participant_token }
}
